/**
 * Skier object
 * Controls all skiers, their physics, and their properties.
 */
Game.Prefabs.Man = function( game, x, y, group ) {

	// Setup Skier.
	//
	// This uses a null display object. This allows me to apply physics to
	// the skier independently of the character display image. I can then
	// snap the character display image to whole pixels - which keeps
	// things looking nice and crisp whilst having accurate physics.
	Phaser.Sprite.call( this, game, x, y, 'player' );

	// Setup Skier Physics.
	game.physics.enable( this, Phaser.Physics.ARCADE );

	// Skier display image.
	this.anchor.setTo( 0.5, 0.5 );

	// Properties.
	this.state = '';
	this.state_old = '';
	this.state_updated = false;
	this.pname = 'skier';

	this.locked = false;
	this.lockedTo = null;

	// Physics Settings.

	// No gravity - it's a top down game and the game physics take care of downward motion.
	this.gravity = 0;

	// Increase tile padding to ensure the character does not pass through tiles by mistake.
	this.body.tilePadding.set( 16, 16 );

	// Not allowed to travel outside world bounds.
	this.body.collideWorldBounds = true;

	this.body.jumpHeight = 0;

	// Skier animations.
	this.animations.add( 'idle', [ 0, 1 ], 2, true );
	this.animations.add( 'walk', [ 2, 3, 4, 5 ], 4, true );
	this.animations.add( 'run', [ 26, 27, 28, 29 ], 6, true );
	this.animations.add( 'jump', [ 6 ], 1, false );
	this.animations.add( 'fall', [ 7 ], 1, false );
	this.animations.add( 'dive', [ 30 ], 1, false );
	this.animations.add( 'idle-crawl', [ 9 ], 1, false );
	this.animations.add( 'crawl', [ 8, 9, 10, 11 ], 5, true );
	this.animations.add( 'wall-slide', [ 12 ], 1, false );
	this.animations.add( 'fly', [ 13, 14 ], 6, true );
	this.animations.add( 'floor-slide', [ 15 ], 1, false );
	this.animations.add( 'idle-climb', [ 16 ], 1, false );
	this.animations.add( 'climb', [ 16, 17 ], 6, true );
	this.animations.add( 'slide-down', [ 18 ], 1, false );
	this.animations.add( 'superhero-landing', [ 19, 20, 21 ], 15, false );
	this.animations.add( 'climb-platform', [ 22, 23, 24, 25 ], 10, false );


	// Add elements to display groups.
	// The order is important. Ensures what needs to be seen, is seen.

	// Add Man.
	group.add( this );

	// Default Height settings.
	this.tile_height = 0;
	this.tile_old_height = 0;

	// Currently playing animation.
	this.animation = '';

	// Initialize the controls.
	this.controls = [];

	// Make sure the player is enabled.
	this.enable();
	this.reset();

};


Game.Prefabs.Man.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Man.constructor = Game.Prefabs.Man;


/**
 * Skier movenent state constants.
 *
 * @type {Object}
 */
Game.Prefabs.Man.states = {
	WALK: 1,
	FLY: 2,
	JUMP: 3,
	FALL: 3,
	CRAWL: 4,
	CLIMB: 5,
	CLIMB_PLATFORM: 6,
	LANDING: 7,
	WALL_SLIDE: 8,
	FLOOR_SLIDE: 9,
	DIVE: 10,
};


/**
 * Player movement stub. Is used in skier-player
 */
Game.Prefabs.Man.prototype.controller = function() { };


/**
 * Player physics stub. Is used in skier-player
 */
Game.Prefabs.Man.prototype.physics = function() {


};


/**
 * Update Skier Positions.
 */
Game.Prefabs.Man.prototype.update = function() {

	// Update movement and physics.
	this.controller();
	this.physics();

	// Check map zones.
	// This decides if the skier should be skiing or walking etc.
	Game.Utils.MapZones.check( this );

	if ( this.alive ) {

		Game.Utils.MapEnvironment.run( this );

	}

	// Player special effects.
	Game.Utils.PlayerEffects.run( this );
	// Run physics.
	Game.Utils.PlayerPhysics.run( this );
	// Run animations.
	Game.Utils.PlayerAnimation.run( this );

	// Update default Phaser sprite stuff.
	Phaser.Sprite.prototype.update.call( this );

	this.check_state();

};


/**
 * Update Skier Positions.
 */
Game.Prefabs.Man.prototype.postUpdate = function() {

	Phaser.Sprite.prototype.postUpdate.call( this );

	Game.Utils.PlayerPhysics.follow( this );

};


/**
 * Check the skier state and update state properties accordingly.
 */
Game.Prefabs.Man.prototype.check_state = function() {

	this.state_updated = false;

	if ( this.state !== this.state_old ) {

		this.state_updated = true;

	}

	this.state_old = this.state;

};


/**
 * Disable a skier so it can no longer ski.
 *
 * Also physics don't affect it.
 */
Game.Prefabs.Man.prototype.disable = function() {

	this.alive = false;
	this.body.enable = false;

};


/**
 * Re-enable a skier so it once again skis the slopes.
 */
Game.Prefabs.Man.prototype.enable = function() {

	this.alive = true;
	this.body.enable = true;

};


Game.Prefabs.Man.prototype.pause = function( delay ) {

	this.body.velocity.x = 0;
	this.body.velocity.y = 0;

	this.pauseTime = game.time.time + delay;

};


/**
 * Reset MAn properties.
 *
 * Resets things like velocity and skiing state.
 */
Game.Prefabs.Man.prototype.reset = function() {

	this.state = Game.Prefabs.Man.states.WALK;

	this.pauseTime = 0;

	// Reset speeds.
	this.body.velocity.x = 0;
	this.body.velocity.y = 0;

	// Reset the bounding box.
	Game.Utils.PlayerPhysics.update_collision( this );

}


/**
 * Make a skier stick to another object.
 *
 * The skier will attach itself to the specified objects location.
 *
 * @param  {Object} parent The object to stick to. Set this to null to
 * break the connection.
 */
Game.Prefabs.Man.prototype.attachTo = function( parent ) {

	if ( !parent ) {
		parent = null;
	}

	this.follow = parent;

};
